/** Загрузка экрана — бледная строка, без спиннера на весь экран. */
export function Loading({ text = "Загружаю…" }: { text?: string }) {
  return <div className="p-5 text-[12.5px] text-fg-faint">{text}</div>;
}
